/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var CardBrand;

(function (CardBrand) {
  CardBrand["Visa"] = "VISA";
  CardBrand["Master"] = "MASTERCARD";
  CardBrand["American"] = "AMERICAN_EXPRESS";
  CardBrand["Discover"] = "DISCOVER";
  CardBrand["Diners"] = "DINERS";
  CardBrand["Maestro"] = "MAESTRO";
  CardBrand["UnionPay"] = "UNIONPAY";
  CardBrand["Jcb"] = "JCB";
  CardBrand["CarteBancaire"] = "CARTE_BANCAIRE";
  CardBrand["Dankort"] = "DANKORT";
  CardBrand["Other"] = "OTHER";
})(CardBrand || (CardBrand = {}));

const getCardBrand = cardNumber => {
  if (RegExp('^4,*').test(cardNumber)) {
    return CardBrand.Visa;
  }

  if (RegExp('^5(1|2|3|4|5),*').test(cardNumber) || RegExp('^2,*').test(cardNumber)) {
    return CardBrand.Master;
  }

  if (RegExp('^3(4|7),*').test(cardNumber)) {
    return CardBrand.American;
  }

  if (RegExp('^6(01|22|44|5),*').test(cardNumber)) {
    return CardBrand.Discover;
  }

  if (RegExp('^3(0|6|8),*').test(cardNumber)) {
    return CardBrand.Diners;
  }

  if (RegExp('^62,*').test(cardNumber)) {
    return CardBrand.UnionPay;
  }

  if (RegExp('^5(0|6|7|8),*').test(cardNumber) || RegExp('^6,*').test(cardNumber)) {
    return CardBrand.Maestro;
  }

  if (RegExp('^35,*').test(cardNumber)) {
    return CardBrand.Jcb;
  }

  return CardBrand.Other;
};

const validateCardNumber = cardNumber => {
  // Accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(cardNumber)) {
    return false;
  }

  const value = cardNumber.replace(/\D/g, ''); // The Luhn Algorithm.

  let sum = 0;
  let isEvenDigit = false;

  for (let i = value.length - 1; i >= 0; i--) {
    const digitChar = value.charAt(i);
    let digit = parseInt(digitChar, 10);

    if (isEvenDigit && (digit *= 2) > 9) {
      digit -= 9;
    }

    sum += digit;
    isEvenDigit = !isEvenDigit;
  }

  const isValid = sum % 10 === 0;
  return isValid;
};

const validateIsCardExpired = cardExpiry => {
  const [month, year] = cardExpiry.split('/');
  const today = new Date();
  const expiryYear = parseInt(`20${year}`, 10);
  const expiryMonth = parseInt(month, 10);

  if (expiryYear > today.getFullYear()) {
    return true;
  }

  if (expiryYear === today.getFullYear() && expiryMonth >= today.getMonth() + 1) {
    return true;
  }

  return false;
};

const validateCardExpiry = cardExpiry => {
  if (cardExpiry.length < 5) {
    return false;
  }

  if (!/^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(cardExpiry)) {
    return false;
  }

  return validateIsCardExpired(cardExpiry);
};

const getCardCvcLengthRangeByBrand = cardBrand => {
  switch (cardBrand) {
    case CardBrand.Visa:
    case CardBrand.Master:
    case CardBrand.Discover:
    case CardBrand.Diners:
    case CardBrand.Maestro:
    case CardBrand.UnionPay:
    case CardBrand.Jcb:
      return {
        min: 3,
        max: 3
      };

    case CardBrand.American:
      return {
        min: 3,
        max: 4
      };

    default:
      return {
        min: 3,
        max: 4
      };
  }
};

const maxLengthValidatorKey = 'maxLength';
const maxLengthValidator = maxLength => {
  return value => {
    const isValid = value !== null && value !== undefined && value.length <= maxLength;
    return {
      [maxLengthValidatorKey]: isValid
    };
  };
};

const minLengthValidatorKey = 'minLength';
const minLengthValidator = minLength => {
  return value => {
    const isValid = !!value && value.length >= minLength;
    return {
      [minLengthValidatorKey]: isValid
    };
  };
};

const patternValidatorKey = 'pattern';
const patternValidator = pattern => {
  return value => {
    const isValid = pattern.test(value);
    return {
      [patternValidatorKey]: isValid
    };
  };
};

const requiredValidatorKey = 'required';
const requiredValidator = value => {
  const isValid = !!value && value.length > 0;
  return {
    [requiredValidatorKey]: isValid
  };
};

const cardExpiryValidatorKey = 'cardExpiry';
const cardExpiryValidator$1 = value => ({
  [cardExpiryValidatorKey]: validateCardExpiry(value)
});

const cardNumberValidatorKey = 'cardNumber';
const cardNumberValidator$1 = value => ({
  [cardNumberValidatorKey]: validateCardNumber(value)
});

const cardExpiryPatternValidator = patternValidator(/^(0[1-9]|1[0-2])\/([0-9]{2})$/);

const cardCvcLengthValidator = cardBrand => {
  var _a, _b;

  const cvcLengthRange = getCardCvcLengthRangeByBrand(cardBrand);
  const cvcMinLengthValidator = minLengthValidator((_a = cvcLengthRange.min) !== null && _a !== void 0 ? _a : Number.MIN_SAFE_INTEGER);
  const cvcMaxLengthValidator = maxLengthValidator((_b = cvcLengthRange.max) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER);
  return value => {
    return Object.assign(Object.assign({}, cvcMinLengthValidator(value)), cvcMaxLengthValidator(value));
  };
};

const stackValidators = (validator1, validator2, validator3, validator4, validator5) => {
  const validators = [validator1, validator2, validator3, validator4, validator5].filter(validator => !!validator);

  const stackedValidator = value => {
    let result = undefined;

    for (const validator of validators) {
      const validationResult = validator(value);
      const keys = Object.keys(validationResult);
      const [key] = keys.filter(param => !validationResult[param]);

      if (key && !validationResult[key]) {
        result = validationResult;
        break;
      }
    }

    return result;
  };

  return stackedValidator;
};

var AuthorizeErrorCode;

(function (AuthorizeErrorCode) {
  AuthorizeErrorCode["Apm"] = "error.authorize.requiresApmAuthorization";
  AuthorizeErrorCode["ThreeDs"] = "error.authorize.requires3DSecure";
})(AuthorizeErrorCode || (AuthorizeErrorCode = {}));

[AuthorizeErrorCode.Apm, AuthorizeErrorCode.ThreeDs];

const TOKEN_PROCESSING_ERROR = {
  Status: 'ERROR',
  ResultCode: '001599',
  ResultMessage: 'Token processing error'
};

const transformCardExpiryDate = expDate => `${expDate.cardExpirationDate.substring(0, 2)}/${expDate.cardExpirationDate.substring(2)}`;

const cardNumberKey = 'cardNumber';
const cardCvxKey = 'cardCvx';
const cardExpirationDateKey = 'cardExpirationDate';
const validationErrors = {
  [`${cardNumberKey}`]: {
    Status: 'ERROR',
    ResultCode: '105202',
    ResultMessage: 'Card number: invalid format'
  },
  [`${cardCvxKey}`]: {
    Status: 'ERROR',
    ResultCode: '105204',
    ResultMessage: 'CVV: missing or invalid format'
  },
  [`${cardExpirationDateKey}`]: {
    Status: 'ERROR',
    ResultCode: '105203',
    ResultMessage: 'Expiry date: missing or invalid format'
  }
};
const getValidationError = key => validationErrors[key];

const cardNumberValidator = stackValidators(requiredValidator, minLengthValidator(14), cardNumberValidator$1);
const cardCvcValidator = cardBrand => stackValidators(requiredValidator, cardCvcLengthValidator(cardBrand));
const cardExpiryValidator = stackValidators(requiredValidator, minLengthValidator(5), maxLengthValidator(5), cardExpiryPatternValidator, cardExpiryValidator$1);

const performValidation = ({
  cardNumber,
  expDateStr,
  cardCvx
}) => {
  const cardBrand = getCardBrand(cardNumber);
  const errors = {
    cardNumber: cardNumberValidator(cardNumber),
    cardCvx: cardCvcValidator(cardBrand)(cardCvx),
    cardExpirationDate: cardExpiryValidator(expDateStr)
  };
  const errorKeys = Object.keys(errors);
  const [invalidParam] = errorKeys.filter(param => typeof errors[param] !== 'undefined');

  if (!invalidParam) {
    return undefined;
  }

  throw getValidationError(invalidParam);
};

const validateCardObject = cardInfo => {
  const expDateStr = transformCardExpiryDate({
    cardExpirationDate: cardInfo.cardExpirationDate
  });
  return performValidation({
    cardNumber: cardInfo.cardNumber,
    cardCvx: cardInfo.cardCvx,
    expDateStr
  });
};

var GooglePayCardAuthMethod;

(function (GooglePayCardAuthMethod) {
  GooglePayCardAuthMethod["PAN_ONLY"] = "PAN_ONLY";
  GooglePayCardAuthMethod["CRYPTOGRAM_3DS"] = "CRYPTOGRAM_3DS";
})(GooglePayCardAuthMethod || (GooglePayCardAuthMethod = {}));

var PaymentConfigurationOptions;

(function (PaymentConfigurationOptions) {
  PaymentConfigurationOptions["CurrencyCode"] = "currencyCode";
  PaymentConfigurationOptions["Amount"] = "amount";
  PaymentConfigurationOptions["Countries"] = "countries";
})(PaymentConfigurationOptions || (PaymentConfigurationOptions = {}));

var SdkOptions;

(function (SdkOptions) {
  SdkOptions["ApiKey"] = "apiKey";
  SdkOptions["ClientId"] = "clientId";
  SdkOptions["UserId"] = "userId";
  SdkOptions["WalletId"] = "walletId";
  SdkOptions["PaymentMethods"] = "paymentMethods";
  SdkOptions["PaymentConfiguration"] = "paymentConfiguration";
  SdkOptions["Branding"] = "branding";
  SdkOptions["Locale"] = "locale";
  SdkOptions["HandlePaymentFlow"] = "handlePaymentFlow";
  SdkOptions["AutoCapture"] = "autoCapture";
  SdkOptions["HideBillingAddress"] = "hideBillingAddress";
  SdkOptions["AllowSaveCard"] = "allowSaveCard";
  SdkOptions["IsSavedCardCvcRequired"] = "isSavedCardCvcRequired";
  SdkOptions["CustomButton"] = "customButton";
  SdkOptions["SupportedCardBrands"] = "supportedCardBrands";
})(SdkOptions || (SdkOptions = {}));

var CheckoutSdkEnvironment;

(function (CheckoutSdkEnvironment) {
  CheckoutSdkEnvironment["SANDBOX"] = "SANDBOX";
  CheckoutSdkEnvironment["PRODUCTION"] = "PRODUCTION";
})(CheckoutSdkEnvironment || (CheckoutSdkEnvironment = {}));

const env = {
  version: "1.0.1",
  apiUrl: "https://api.mangopay.com/V2.01",
  sandboxApiUrl: "https://api.sandbox.mangopay.com/v2.01",
  nethoneProfilerUrl: "https://d1lzh62h7g9ee9.cloudfront.net/s/428242/dvIJzO.js"
}; // eslint-disable-next-line import/no-extraneous-dependencies

const getApiUrl = (apiKey, environment) => environment === CheckoutSdkEnvironment.PRODUCTION ? env.apiUrl : env.sandboxApiUrl;

class HttpClient {
  constructor(apiKey, clientId) {
    this.apiKey = apiKey;
    this.clientId = clientId;
  }

  isFormUrlEncoded(contentType) {
    return contentType === 'application/x-www-form-urlencoded';
  }

  async request(url, data, method = 'POST', contentType = 'application/json', idempotencyKey) {
    const headers = new Headers();

    if (!!this.apiKey && !!this.clientId) {
      const authToken = btoa(`${this.clientId}:${this.apiKey}`);
      headers.append('Authorization', `Basic ${authToken}`);
    }

    headers.append('Content-Type', contentType);

    if (contentType === 'application/json') {
      headers.append('X-SDK-Version', env.version);
      headers.append('User-Agent', '<product> / <product-version>');
    }

    if (!!idempotencyKey) {
      headers.append('Idempotency-Key', idempotencyKey);
    }

    const requestOptions = {
      method,
      headers,
      redirect: 'follow'
    };

    if (method !== 'GET') {
      requestOptions.body = this.isFormUrlEncoded(contentType) ? new URLSearchParams(data) : JSON.stringify(data);
    }

    return fetch(url, requestOptions).then(response => {
      if (response.status === 0) {
        // in a browser its shown as 499, however the client computer blocks the call even before it's able to do the Payline request (most likely due to an antivirus)
        throw {
          Status: 'ERROR',
          ResultCode: '001596',
          ResultMessage: "An HTTP request was blocked by the User's computer (probably due to an antivirus)"
        };
      }

      return this.isFormUrlEncoded(contentType) ? response.text() : response.json();
    });
  }

}

const updateCardRegistration = async (data, environment) => {
  const apiUrl = getApiUrl('', environment);

  const {
    ClientId
  } = data,
        payload = __rest(data, ["ClientId"]);

  const cardRegistrationId = data.CardRegistrationId;
  const client = new HttpClient('', ClientId);
  const updateCardRegistrationUrl = `${apiUrl}/${ClientId}/cardregistrations/${cardRegistrationId}`;
  return client.request(updateCardRegistrationUrl, payload, 'PUT');
};

const postCardInfo = async input => {
  const client = new HttpClient();

  const {
    cardRegistrationURL
  } = input,
        payload = __rest(input, ["cardRegistrationURL"]);

  const contentType = 'application/x-www-form-urlencoded';
  const data = await client.request(cardRegistrationURL, payload, 'POST', contentType);
  return {
    data
  };
};

class VaultSdk {
  constructor(options) {
    this.clientId = options.clientId;
    this.environment = options.environment;
  }

  async tokenizePaymentMethod(cardInfoObject, preregistrationData) {
    if (!preregistrationData) {
      throw {
        Status: 'ERROR',
        ResultCode: '105206',
        ResultMessage: 'Registration data : Invalid format'
      };
    }

    validateCardObject(cardInfoObject);

    const {
      id
    } = preregistrationData,
          postCardPreregistrationData = __rest(preregistrationData, ["id"]);

    const postCardInfoResult = await postCardInfo(Object.assign(Object.assign({}, postCardPreregistrationData), cardInfoObject));
    const registrationData = postCardInfoResult === null || postCardInfoResult === void 0 ? void 0 : postCardInfoResult.data;

    if (!(registrationData === null || registrationData === void 0 ? void 0 : registrationData.startsWith('data='))) {
      throw TOKEN_PROCESSING_ERROR;
    }

    if (registrationData !== null && (registrationData === null || registrationData === void 0 ? void 0 : registrationData.indexOf('errorCode=')) === 0) {
      throw {
        Status: 'ERROR',
        ResultCode: registrationData === null || registrationData === void 0 ? void 0 : registrationData.replace('errorCode=', ''),
        ResultMessage: 'Token processing error'
      };
    } else if (registrationData === null) {
      throw TOKEN_PROCESSING_ERROR;
    }

    return updateCardRegistration({
      ClientId: this.clientId,
      RegistrationData: registrationData,
      CardRegistrationId: id
    }, this.environment);
  }

}

// eslint-disable-next-line import/no-extraneous-dependencies
class MangopayVault {
  static initialize(options) {
    if (!options.clientId) {
      throw new Error('Client ID is missing.');
    }

    return new VaultSdk(options);
  }

}

export { MangopayVault, VaultSdk };
//# sourceMappingURL=index.js.map
